// extracted by mini-css-extract-plugin
export default {"fillPage":"style_fillPage__ZAmEM","box":"style_box__iPD6S","xButton":"style_xButton__Ha7ST","title":"style_title__EPm+0","message":"style_message__kR5B2"};